<template>
	<div>
		<van-sticky>
			<van-search v-model="search" placeholder="请输入搜索关键词"  @input="onSearch"/>
		</van-sticky>
		<van-radio-group v-model="radio" v-if="type == 'radio'">
			<van-cell-group>
				<van-list :v-model="list.loading" :finished="list.finished" finished-text="没有更多了" @load="onLoad">
					<div class="van-clearfix">
						<van-cell v-for="(item, index) in list.list" :key="index" :title="item[valueKey]" clickable
							@click="check(item, index)">
							<template #right-icon>
								<van-radio :name="index" />
							</template>
						</van-cell>
					</div>
				</van-list>
			</van-cell-group>
		</van-radio-group>

		<van-checkbox-group v-model="checkbox" v-else>
			<van-cell-group>
				<van-list :v-model="list.loading" :finished="list.finished" finished-text="没有更多了" @load="onLoad">
					<div class="van-clearfix">
						<van-cell v-for="(item, index) in list.list" :key="item[idKey]" :title="item[valueKey]"
							clickable @click="checkboxs(item, index)">
							<template #right-icon>
								<van-checkbox :name="item[idKey]" />
							</template>
						</van-cell>
					</div>
				</van-list>
			</van-cell-group>
		</van-checkbox-group>
	</div>
</template>

<script>
// import { debounce } from 'lodash';
export default {
	name: "popupselect",
	data() {
		return {
			container: null,
			search: "",
			radio: "",
			checkbox: [],
			list: {
				loading: false,
				finished: false,
				list: []
			}
		};
	},
	model: {
		prop: "vModel"
	},
	props: {
		vModel: Array,
		loading: Boolean,
		finished: Boolean,
		valueKey: {
			type: String,
			default: function () {
				return "text";
			}
		},
		idKey: {
			type: String,
			default: function () {
				return "id";
			}
		},
		type: {
			type: String,
			default: function () {
				return "radio";
			}
		},
		value: {
			type: Array,
			default: function () {
				return [];
			}
		}
	},
	methods: {
		onLoad() {
			this.$emit("onload");
		},
		check(item, index) {
			this.radio = index;
			this.$emit("check", item);
		},
		checkboxs(item) {
			let indexof = this.checkbox.indexOf(item[this.idKey]);
			if (indexof > -1) {
				this.$emit("check", item, "del", indexof);
			} else {
				this.$emit("check", item, "add", indexof);
			}
		},
		onSearch() {
			console.log(1);
			this.$emit("onload", this.search);
		},
		change() {
			console.log(2);
			this.$emit("onload", this.search);
		},
	},
	watch: {
		vModel: {
			immediate: true,
			handler(newV) {
				this.list.list = newV;
			}
		},
		loading: {
			immediate: true,
			handler(newV) {
				this.list.loading = newV;
			}
		},
		finished: {
			immediate: true,
			handler(newV) {
				this.list.finished = newV;
			}
		},
		value: {
			immediate: true,
			handler(newV) {
				this.checkbox = newV;
			}
		}
	}
};
</script>

<style></style>
